module.exports = __webpack_public_path__ + "static/sprint-211b4105582a8b337a461f54ab05bd1e.png";